import React, { useState } from "react"
import { useSelector } from "react-redux";
import { ReflectionActionsEnum } from "../../Shared/ReflectionActionsEnum"
import classes from './ReflectionNumbersType.module.css'
import Lines from '../../../assests/reflection/lines.png';
import { calculatePercentage } from "../../Shared/ReportPercentageCalculation";

const ReflectionNumbersType = ({ action, question, isStudent, answerValue, setAnswerValue }) => {
    const texts = useSelector(state => state.translate.texts);

    switch (action) {

        case ReflectionActionsEnum.CRUD:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <div className={classes.NumbersLine}>
                        <div>{texts.notAtAll}</div>
                        <div className={classes.Numbers}>
                            {[1, 2, 3, 4, 5].map(num => <div key={num} className={`${classes.Num}`}>{num}</div>)}
                        </div>
                        <div>{texts.very}</div>
                    </div>
                </div>
            )

        case ReflectionActionsEnum.View:
            return (
                <div className={classes.CreateType}>
                    <div className={classes.Text}>{question && question.text ? question.text : <img className={classes.Lines} src={Lines} />}</div>
                    <div className={classes.NumbersLine}>
                        <div>{texts.notAtAll}</div>
                        <div className={classes.Numbers}>
                            {[1, 2, 3, 4, 5].map(num => <div key={num} className={`${num === answerValue && classes.CurrentNum} ${classes.Num} ${isStudent && classes.NumView}`} onClick={() => isStudent && setAnswerValue(num)}>{num}</div>)}
                        </div>
                        <div>{texts.very}</div>
                    </div>
                </div>)

        case ReflectionActionsEnum.Report:
            const percentageData = calculatePercentage(question.submissions, 5);
            const maxPercentage = Math.max(...percentageData.map(answer => answer.percentage));

            return (
                <div className={classes.ReportType}>
                    <p className={classes.ReportQuestion}>{question.name}</p>
                    <div className={classes.BarChart}>
                        {calculatePercentage(question.submissions, 5).map((answer, index) => {
                            return <div key={index} className={classes.BarLine} style={{ height: `${answer.percentage + 3}%`, backgroundColor: answer.percentage === maxPercentage && '#73DED8' }} />
                        }
                        )}
                    </div>
                    <div className={classes.NumbersLine}>
                        <div>{texts.notAtAll}</div>
                        <div className={classes.Numbers}>
                            {[1, 2, 3, 4, 5].map(num => <div key={num} className={`${classes.Num}`}>{num}</div>)}
                        </div>
                        <div>{texts.very}</div>
                    </div>
                </div>)

        default:
            return null
    }

}

export default ReflectionNumbersType
